<template>
  <div class="tw:flex tw:justify-between tw:w-full tw:flex-col">
    <div class="tw:w-full tw:justify-between tw:flex tw:flex-col tw:md:flex-row tw:gap-4">
      <div class="tw:w-2/3">
        <p class="tw:text-xl tw:font-bold">{{ $t('app_images_header_title') }}</p>
        <div>
          <p v-html="$t('app_images_header_text')" class="tw:hidden tw:mt-2 tw:md:inline tw:text-sm" />
          <i18n-t
            keypath="app_images_header_text_2"
            tag="p"
            class="tw:hidden tw:mt-2 tw:md:inline tw:text-sm"
            scope="global"
          >
            <template #LearnMore>
              <a
                class="tw:text-blue-700 tw:hover:text-blue-800 tw:text-center tw:cursor-pointer tw:transition-colors tw:hover:no-underline tw:duration-300 tw:text-sm"
                @click="emit('toggleTipsModal')"
                @keydown.enter="emit('toggleTipsModal')"
              >
                {{ $t('app_images_header_learn_more') }}
              </a>
            </template>
          </i18n-t>
        </div>
      </div>
      <div class="tw:mt-4 tw:md:mt-0 tw:hidden tw:md:flex tw:w-auto tw:items-start tw:whitespace-nowrap">
        <DangerButton :disabled="deleteDisabled" size="medium" class="tw:px-9 tw:mr-2" @click="emit('deleteImages')">{{
          $t('app_images_actions_delete')
        }}</DangerButton>

        <MainButton size="medium" class="tw:px-5" @click="openAddImagesPopup">
          <span class="tw:text-nowrap">{{ $t('nba_cta_expired_hotelier_images') }}</span></MainButton
        >
      </div>
      <div>
        <p v-html="$t('app_images_header_text')" class="tw:md:hidden tw:mt-2 tw:inline tw:text-sm tw:mr-1" />
        <i18n-t
          keypath="app_images_header_text_2"
          tag="p"
          class="tw:md:hidden tw:mt-2 tw:inline tw:text-sm"
          scope="global"
        >
          <template #LearnMore>
            <a
              class="tw:text-blue-700 tw:hover:text-blue-800 tw:text-center tw:cursor-pointer tw:transition-colors tw:hover:no-underline tw:duration-300 tw:text-sm"
              @click="emit('toggleTipsModal')"
              @keydown.enter="emit('toggleTipsModal')"
            >
              {{ $t('app_images_header_learn_more') }}
            </a>
          </template>
        </i18n-t>
      </div>
    </div>

    <div class="tw:mt-4 tw:md:mt-0 tw:md:hidden tw:flex tw:justify-end">
      <DangerButton :disabled="deleteDisabled" size="medium" class="tw:px-9 tw:mr-2" @click="emit('deleteImages')">{{
        $t('app_images_actions_delete')
      }}</DangerButton>

      <MainButton size="medium" class="tw:px-5" @click="openAddImagesPopup">{{
        $t('nba_cta_expired_hotelier_images')
      }}</MainButton>
    </div>
  </div>
</template>
<script setup>
import MainButton from '@/components/base/buttons/MainButton.vue'
import DangerButton from '@/components/base/buttons/DangerButton.vue'
import appAnalytics from '@/utils/tracking'

import { selectedAccommodationId } from '@/layouts/queries'

const emit = defineEmits(['toggleTipsModal', 'deleteImages', 'openAddImageModal'])
defineProps({
  deleteDisabled: Boolean,
  canUploadImage: Boolean,
})

const openAddImagesPopup = () => {
  appAnalytics.track(appAnalytics.events.PD_ADD_NEW_IMAGES_OPEN, {
    item_id: selectedAccommodationId.value,
  })
  emit('openAddImageModal')
}
</script>
